import React from 'react';
import { NavLink } from 'react-router-dom';
// @ts-ignore
import SiteLogo from 'assets/images/FLHealthLogo2.png';
// @ts-ignore
import Hexagons from 'assets/images/Hexagons2.png';
import { envConfig } from 'utility/env_config';
import { MenuItemType } from 'utility/enumerations';
import { MainMenu } from './main_menu';
import { UserMenu } from './user_menu';
// @ts-ignore
import styles from './site.module.scss';

interface DesktopHeaderProps {
  authenticated: boolean,
  user: any,
  history: any
}

export const DesktopHeader = (props: DesktopHeaderProps) => {
  const getMainMenuItems = () => {
    const home = {
      text: 'Home',
      type: MenuItemType.Navigation,
      route: '/',
      parentId: 0
    };
    const login = {
      text: 'Login',
      type: MenuItemType.Navigation,
      route: '/login',
      parentId: 0
    };

    if (!props.authenticated) {
      return [home, login];
    }

    const mainMenu = props.user?.menuNavigationDtos
      ?.filter((menuNavigationDto) => menuNavigationDto.userMenu === false);

    if (!mainMenu) {
      return [];
    }

    const items = mainMenu.map((menuItem) => ({
      text: menuItem.text,
      icon: menuItem.icon,
      type: MenuItemType.Navigation,
      route: menuItem.route,
      parentId: menuItem.parentMenuItemPermissionId,
      children: menuItem.childMenuNavigationDtos
    }));

    const logout = {
      text: 'Log Out',
      type: MenuItemType.Navigation,
      route: '/logout',
      parentId: 0
    };

    items.push(logout);

    if (envConfig.enableDevLinks) {
      const sandbox = {
        text: 'Sandbox',
        type: MenuItemType.Navigation,
        route: '/sandbox',
        parentId: 0
      };

      const variables = {
        text: 'Vars',
        type: MenuItemType.Navigation,
        route: '/vars',
        parentId: 0
      };

      items.splice(0, 0, sandbox);
      items.splice(0, 0, variables);
    }

    return items;
  };

  const getUserMenuItems = () => {
    const { user } = props;
    const userMenu = props.user?.menuNavigationDtos?.filter((menuNavigationDto) => menuNavigationDto.userMenu === true);

    if (!userMenu) {
      return [];
    }

    const items = userMenu.map((menuItem) => ({
      text: menuItem.text,
      icon: menuItem.icon,
      type: MenuItemType.Navigation,
      route: menuItem.route,
    }));

    const logout = {
      text: 'Log Out',
      icon: 'sign-out-alt',
      type: MenuItemType.Navigation,
      route: '/logout',
    };

    items.push(logout);

    const headerItem = {
      text: [`${user.firstName} ${user.lastName}`, user.emailAddress],
      icon: 'user',
      type: MenuItemType.Navigation,
      route: '/',
    };

    items.splice(0, 0, headerItem);

    return items;
  };

  return (
    <header className={styles.header}>
      <div className={styles.banner}>
        <div className={styles.brand}>
          <NavLink style={{ textDecoration: 'none' }} to="/">
            <img alt="OMMU Site Logo" className={styles.logo} src={SiteLogo} />
            <span className={styles.headerSiteText}>Medical Marijuana Use Registry</span>
          </NavLink>
        </div>
        <div className={styles.bannerRight}>
          <img alt="Banner Hexagons" className={styles.bannerHexagons} src={Hexagons} />
          {props.authenticated
            && (
              <UserMenu
                menuItems={getUserMenuItems()}
                history={props.history}
                animationPlaybackEvent={undefined}
                dropdownId={undefined}
              />
            )}
        </div>
      </div>
      <MainMenu menuItems={getMainMenuItems()} history={props.history} />
    </header>
  );
};
